var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var NoteText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color: ", ";\n"], ["\n  display: block;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
});
var templateObject_1;
//# sourceMappingURL=NoteText.js.map